import React, {useState, useContext} from 'react';
import {Platform, Text, View} from 'react-native';
import {useTranslation} from 'react-i18next';
import * as Sentry from 'sentry-expo';

import {UserContext} from '../../contexts/UserContext';
import {ThemeContext} from '../../contexts/ThemeContext';
import Api from '../../constants/Api';
import StyledButton from '../../components/StyledButton';
import RadioButton from '../../components/RadioButton';

import OnboardingLayout from './components/OnboardingLayout';

const GenderScreen = ({navigation}) => {
  const {t} = useTranslation();
  const {setUser, user, userId, userToken} = useContext(UserContext);
  const theme = useContext(ThemeContext);

  const [loading, setLoading] = useState(false);
  const [gender, setGender] = useState((user || {}).gender || '');
  const [errorMessage, setErrorMessage] = useState(null);

  const handlePress = async () => {
    console.log('gender', gender, gender.length);
    if (!gender.length) {
      setErrorMessage(t('GenderScreen.errors.missing', 'Please choose an option to continue.'));
      return;
    }

    try {
      setErrorMessage(null);
      setLoading(true);

      const response = await fetch(`${Api.apiBaseUrl}/users/${userId}`, {
        method: 'PATCH',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_token: userToken,
          gender: gender,
        }),
      });

      const responseJson = await response.json();

      console.log('#######responseJson');
      console.log(responseJson);

      setLoading(false);

      if(responseJson && responseJson.gender === gender) {
        setUser(responseJson);
        navigation.navigate('Username', {onboarding: true});
      } else {
        setErrorMessage(responseJson.gender);
      }

      return responseJson;
    } catch (error) {
      console.error('error');

      if (Platform.OS === 'web') {
        Sentry.Browser.captureException(error);
      } else {
        Sentry.Native.captureException(error);
      }
    }
  };

  return (
    <OnboardingLayout footer={<StyledButton text={t('OnboardingLayout.continue', 'Continue →')} loading={loading} onPress={handlePress}/>}>
      <View style={{minWidth: 300}}>
        <Text
          style={{
            textAlign: 'center',
            color: theme.textPrimary,
            fontSize: 16,
            fontWeight: 'bold',
            marginBottom: 16,
          }}
        >
          {t('GenderScreen.label', 'What is your gender ?')}
        </Text>

        {errorMessage
          ? (
            <Text style={{textAlign: 'center', color: 'red', marginBottom: 10, fontSize: 16}}>
              {errorMessage}
            </Text>
          ) : null
        }

        <View style={{flexDirection: 'column', gap: 12}}>
          <RadioButton
            text={t('GenderScreen.options.male.text', 'Male')}
            selected={gender === 'male'}
            onPress={() => setGender('male')}
          />

          <RadioButton
            text={t('GenderScreen.options.female.text', 'Female')}
            selected={gender === 'female'}
            onPress={() => setGender('female')}
          />

          <RadioButton
            text={t('GenderScreen.options.noAnswer.text', 'I do not wish to answer')}
            selected={gender === 'na'}
            onPress={() => setGender('na')}
          />
        </View>
      </View>
    </OnboardingLayout>
  );
};

export default GenderScreen;
